<ng-template let-property #label>
	<div class="property-label">
		<div class="text">
			<span class="h4" translate="{{ getNameKey(property) }}"></span>
			@if (property.isLinkable) {
				<span class="h6">
					<a [routerLink]="getLink(property)">{{ getDisplayValue(property) }}</a>
				</span>
			}
			@if (!property.isLinkable) {
				@if (!hasHtmlValue(property)) {
					<p class="preformatted">{{ getDisplayValue(property) }}</p>
				}
				@if (hasHtmlValue(property)) {
					<stages-description-view [html]="getHTMLValue(property)"> </stages-description-view>
				}
			}
			@if (getChangeMarker(property) && getChangeMarker(property).added) {
				<p>
					<span class="badge added-badge" translate="process.compare.added"></span>
				</p>
			}
			@if (getChangeMarker(property) && getChangeMarker(property).deleted) {
				<p>
					<span class="badge deleted-badge" translate="process.compare.deleted"></span>
				</p>
			}
		</div>
	</div>
</ng-template>

<ng-template let-property #buttonbar>
	<div class="input-container right">
		<button type="submit" class="button sm save" name="submit" [disabled]="isSaveInProgress">
			@if (!isSaveInProgress) {
				<span translate="save"></span>
			}
			@if (isSaveInProgress) {
				<stages-spin size="s"></stages-spin>
			}
		</button>
		<input
			type="button"
			class="button sm cancel"
			(mousedown)="cancel()"
			(click)="cancel()"
			value="{{ 'cancel' | translate }}"
		/>
	</div>
</ng-template>

@if (currentElement) {
	<article class="properties-grid module" [ngClass]="{ 'has-categories': hasCategories() }">
		@if (!editOn) {
			@if (showTranslateNone(propertyList()) && translateNone) {
				<p class="empty" translate="{{ translateNone }}"></p>
			}
			@if (hasCategories()) {
				<ul class="grouped-list">
					@for (category of getVisiblePropertyList(); track category; let last = $last) {
						<li class="group" [ngClass]="{ last: last }">
							<header class="group-header">
								<span class="h3" (click)="toggle(category)">
									{{ category.nameKey | translate
									}}<span class="counter">{{ getVisiblePropertiesCount(category) }}</span>
								</span>
								<stages-button-expand-collapse
									[classes]="'action menu-button'"
									[isCollapsed]="!isCategoryOpen(category)"
									(pressedButton)="toggle(category)"
								></stages-button-expand-collapse>
							</header>
							@if (isCategoryOpen(category)) {
								<div class="relative-container">
									<div class="animation-container">
										<div class="expandable">
											<ul class="list dense">
												@for (property of category.properties; track property) {
													@if (show(property)) {
														<li class="list-item">
															<ng-container *ngTemplateOutlet="label; context: { $implicit: property }"></ng-container>
														</li>
													}
												}
											</ul>
										</div>
									</div>
								</div>
							}
						</li>
					}
				</ul>
			}
			@if (!hasCategories()) {
				<ul class="grouped-list panel-component">
					<li>
						<ul class="list dense">
							@for (property of propertyList(); track property) {
								@if (show(property)) {
									<li class="list-item">
										<ng-container *ngTemplateOutlet="label; context: { $implicit: property }"></ng-container>
									</li>
								}
							}
						</ul>
					</li>
				</ul>
			}
		}
		@if (editOn) {
			<form
				[formGroup]="form"
				class="form widget-spacer-top-bottom"
				name="form"
				(ngSubmit)="onSave()"
				novalidate
				stagesFocusError
			>
				<ng-container *ngTemplateOutlet="buttonbar"></ng-container>
				<stages-attribute-edit
					[form]="form"
					[attributeTypes]="editableAttributeTypes"
					[attributes]="editableAttributes"
					[richtextInputContext]="getContext()"
				>
				</stages-attribute-edit>
				<ng-container *ngTemplateOutlet="buttonbar"></ng-container>
			</form>
		}
	</article>
}

